import { render, staticRenderFns } from "./AddUser.vue?vue&type=template&id=13097dc0&scoped=true&"
import script from "./AddUser.vue?vue&type=script&lang=js&"
export * from "./AddUser.vue?vue&type=script&lang=js&"
import style0 from "./AddUser.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./AddUser.vue?vue&type=style&index=1&id=13097dc0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13097dc0",
  null
  
)

export default component.exports